import Responsable from "../../../Responsable";
import BaseSection from "../../BaseSection";
import ScrollOverlayProjects from "../scrollOverays/ScrollOverlayProjects";
import { useRef } from "react";

const HomeSection03_1 = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <BaseSection ref={containerRef}>
      <Responsable
        pc={<ScrollOverlayProjects screenType="PC" />}
        tablet={<ScrollOverlayProjects screenType="TABLET" />}
        mobile={<ScrollOverlayProjects screenType="MOBILE" />}
      />
    </BaseSection>
  );
};
export default HomeSection03_1;
